import { render } from "./MFITTBookingDivisionAdult.vue?vue&type=template&id=3896a174&scoped=true"
import script from "./MFITTBookingDivisionAdult.vue?vue&type=script&lang=js"
export * from "./MFITTBookingDivisionAdult.vue?vue&type=script&lang=js"

import "./MFITTBookingDivisionAdult.vue?vue&type=style&index=0&id=3896a174&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3896a174"

export default script